import "../Dashboard/dashboard.css"
import React, { useEffect, useState } from 'react';
import Topbar from '../../components/Topbar';
import Leftbar from '../../components/Leftsidebar';
import { Link } from 'react-router-dom';
import { Tooltip } from 'react-tooltip'
import Loaderspinner from "../../components/Loader";
import { getAdminList, updateAdminRole, deleteAdmin, showToast, usTimezone } from "../Utils/utils";
import ReactPaginate from 'react-paginate';
import { Row, Col } from "react-bootstrap";
import SweetAlert from "react-bootstrap-sweetalert";


const Admin = () => {
    const [showSidebar, setShowSidebar] = useState(false);
    const [adminList, setAdminList] = useState([]);
    const [search, setSearch] = useState("");
    const [roleSearch, setRoleSearch] = useState("");
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false)
    const [adminId, setAdminId] = useState(null);
    const [showAlert, setShowAlert] = useState(false);

    const role = localStorage.getItem("role")

    useEffect(() => {
        if (search.length == 0 || search.length >= 3) {
            fetchList();
        }
    }, [page, search, roleSearch]);

    const fetchList = async () => {
        try {
            setLoading(true)
            const limit = 10;
            const offset = page * limit;

            const response = await getAdminList({
                search: search,
                role: roleSearch,
                limit,
                offset,
            });
            setAdminList(response?.data || []);
            if ((response?.data?.length || 0) < limit) {
                setTotalPages(page + 1);
            } else {
                setTotalPages(page + 2);
            }
        } catch (error) {
            console.error("Error fetching admins:", error);
        } finally {
            setLoading(false)
        }
    };

    const handleSidebar = () => {
        setShowSidebar(!showSidebar);
    };

    const handleSidebarClose = () => {
        setShowSidebar(false);
    };

    const handleRoleUpdate = async (id, value) => {
        try {
            setLoading(true)

            const response = await updateAdminRole({ id, value });
            if (response.status == 200) {
                showToast("Role updated successfully", "success");
                fetchList()
            } else {
                showToast("Unable to update role", "error");
            }
        } catch (error) {
            console.error("Error updating role:", error);
        } finally {
            setLoading(false)
        }
    }

    const handleDelete = async () => {
        try {
            const response = await deleteAdmin(adminId);
            if (response.status == 200) {
                showToast("Admin deleted successfully", "success");
                fetchList();
            } else {
                showToast(response?.data?.message || "Unable to delete admin", "error");
            }
        } catch (error) {
            console.error("Error deleting admin:", error);
            showToast(error?.message || "Unable to delete admin", "error");
        } finally {
            setShowAlert(false);
        }
    };

    const formatRole = (role) => {
        const map = {
            super_admin: 'Super Admin',
            admin: 'Admin',
            virtual_assistant: 'Virtual Assistant',
            transaction_cordinator: 'Transaction Coordinator',
        };
        return map[role] ?? role;
    };


    return (
        <>
            {loading && <Loaderspinner />}
            <div className="g-sidenav-show bg-gray-100 min-vh-100">
                <div id="wrapper">
                    <Leftbar showSidebar={showSidebar} handleSidebarClose={handleSidebarClose} />
                    <main className="main-content border-radius-lg">
                        <Topbar handleSidebar={handleSidebar} />
                        <div className="header header-bg-lender pt-3">
                            <div className="col-lg-6 col-7">
                                <nav aria-label="breadcrumb" className="d-none d-md-inline-block ml-md-4" style={{ marginLeft: '30px' }}>
                                    <ol className="breadcrumb breadcrumb-links breadcrumb-dark" style={{ background: "transparent" }}>
                                        <li className="breadcrumb-item"><Link to="/dashboard"><i className="fas fa-home" /></Link></li>
                                        <li className="breadcrumb-item mt-2"><span className='' style={{ color: "#f6f9fc" }}>Admin</span></li>
                                    </ol>
                                </nav>
                            </div>

                        </div>
                        <div className="container-fluid mt--6">
                            <div className="row">
                                <div className="col">
                                    <div className="card">
                                        <div className="card-header border-0">
                                            <div className="d-flex justify-content-between">
                                                <div className="row ">
                                                    <h5 className="mb-0 w-auto">Admin</h5>
                                                    {/* <p
                                                        className="w-auto px-0"
                                                        data-tooltip-id="my-tooltip"
                                                        data-tooltip-content="A complete list of all projects created by borrowers. Use this report to review project details, check status, and ensure projects comply with platform guidelines."
                                                        data-tooltip-place="right"
                                                    >
                                                        <i className="fas fa-info-circle" />

                                                    </p>

                                                    <Tooltip id="my-tooltip" style={{ width: '30%' }} /> */}
                                                </div>
                                                <div className="d-flex align-items-center">
                                                    <input
                                                        type="text"
                                                        className="search-input mx-2"
                                                        placeholder="Search"
                                                        value={search}
                                                        onChange={(e) => setSearch(e.target.value)}
                                                    />
                                                    <select
                                                        className="custom-select-dropdown font-bold"
                                                        value={roleSearch}
                                                        onChange={(e) => setRoleSearch(e.target.value)}
                                                    >
                                                        <option value="" className='option'>All</option>
                                                        <option value="super_admin" className='option'>Super Admin</option>
                                                        <option value="admin" className='option'>Admin</option>
                                                        <option value="virtual_assistant" className='option'>Virtual Assistant</option>
                                                        <option value="transaction_cordinator" className='option'>Transaction cordinator</option>
                                                    </select>
                                                    {role == "super_admin" && (
                                                        <Link to="/create-admin">
                                                            <button className="export-btn mx-2">
                                                                <span className="text-white">Create Admin</span>
                                                            </button>
                                                        </Link>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="table-responsive">
                                            <table className="table align-items-center table-flush">
                                                <thead className="thead-light">
                                                    <tr>
                                                        <th>Name</th>
                                                        <th>Email</th>
                                                        <th>Role</th>
                                                        <th>Created At</th>
                                                        <th>Last Deal Assigned At</th>
                                                        <th>Action</th>
                                                        {role == "super_admin" && <th>Delete</th>}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {adminList?.length > 0 ? (
                                                        adminList.map((admin, index) => (
                                                            <tr key={index}>
                                                                <td className="table-user">
                                                                    <div>
                                                                        <span>{admin?.first_name + " " + admin?.last_name}</span>
                                                                    </div>
                                                                </td>
                                                                <td className="table-user">
                                                                    <div style={{ width: "180px" }}><span>{admin?.email}</span></div>
                                                                </td>
                                                                <td className="table-user">
                                                                    {admin?.role == "super_admin" ? "Super admin" : admin?.role == 'admin' ? "Admin" : admin?.role == 'virtual_assistant' ? "Virtual Assistant" : "Transaction cordinator"}
                                                                </td>
                                                                <td>
                                                                    {admin?.createdAt
                                                                        ? usTimezone(admin.createdAt)
                                                                        : '-'}
                                                                </td>
                                                                <td>
                                                                    <div style={{ width: "140px" }}>
                                                                        {admin?.last_assigned_at
                                                                            ? usTimezone(admin.last_assigned_at)
                                                                            : '-'}
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div style={{ width: "180px" }}>
                                                                        {role == "super_admin" ? (
                                                                            <select
                                                                                className="custom-select-dropdown font-bold"
                                                                                value={admin.role}
                                                                                onChange={(e) => handleRoleUpdate(admin?.id, e.target.value)}
                                                                                disabled={role == "admin"}
                                                                            >
                                                                                <option value="super_admin" className='option'>Super Admin</option>
                                                                                <option value="admin" className='option'>Admin</option>
                                                                                <option value="virtual_assistant" className='option'>Virtual Assistant</option>
                                                                                <option value="transaction_cordinator" className='option'>Transaction cordinator</option>
                                                                            </select>
                                                                        ) : (
                                                                            <span className="custom-select-dropdown font-bold text-gray-700 d-flex align-items-center">
                                                                                {formatRole(admin.role)}
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                </td>
                                                                {role == "super_admin" && (
                                                                    <td>
                                                                        <button
                                                                            className="viewproject-btn"
                                                                            style={{ width: "auto", minWidth: '100px' }}
                                                                            onClick={() => {
                                                                                setAdminId(admin?.id);
                                                                                setShowAlert(true);
                                                                            }}
                                                                        >
                                                                            <span className="text-white">Delete</span>
                                                                        </button>
                                                                    </td>
                                                                )}
                                                            </tr>
                                                        ))) :
                                                        <tr>
                                                            <td colSpan="10" className="text-center"><b>No records found</b></td>
                                                        </tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Row>
                                <Col xs={12}>
                                    <div className='paginate-css'>
                                        <ReactPaginate
                                            previousLabel="<"
                                            nextLabel=">"
                                            breakLabel="..."
                                            pageCount={totalPages}
                                            marginPagesDisplayed={1}
                                            pageRangeDisplayed={2}
                                            onPageChange={({ selected }) => setPage(selected)}
                                            containerClassName="pagination"
                                            activeClassName="active"
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </main>
                    {showAlert && (
                        <SweetAlert
                            warning
                            showCancel
                            confirmBtnText="Yes, delete it!"
                            confirmBtnBsStyle="danger"
                            cancelBtnBsStyle="secondary"
                            title="Are you sure?"
                            onConfirm={handleDelete}
                            onCancel={() => setShowAlert(false)}
                            focusCancelBtn
                        >
                            This action cannot be undone.
                        </SweetAlert>
                    )}
                </div>
            </div>
        </>

    );
};

export default Admin;
